export enum ActionPosition {
    ONBOADING = 'Onboarding',
    DASHBOARD = 'Dashboard',
    KEYWORDS = 'Keywords',
}